import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import styles from "./ThemeToggle.module.scss";
import { useTheme } from "../../../context/ThemeContext";
import type { Theme } from "../../../context/ThemeContext";
import SunIcon from "../../../assets/svgs/header/SunIcon";
import MoonIcon from "../../../assets/svgs/header/MoonIcon";

const ThemeToggle = () => {
  const { theme, isDark, setTheme } = useTheme();
  const { t } = useTranslation("translation");

  const options: { value: Theme; label: string; icon: ReactElement }[] = [
    {
      value: "light",
      label: t("theme.light", "Light") as string,
      icon: <SunIcon />,
    },
    {
      value: "dark",
      label: t("theme.dark", "Dark") as string,
      icon: <MoonIcon />,
    },
  ];

  return (
    <div
      className={styles.toggle}
      role="group"
      aria-label={t("theme.label", "Theme") as string}
    >
      <span
        className={`${styles.thumb} ${isDark ? styles.thumb_dark : ""}`}
        aria-hidden="true"
      />
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`${styles.option} ${
            theme === option.value ? styles.active : ""
          }`}
          onClick={() => setTheme(option.value)}
          aria-pressed={theme === option.value}
          title={option.label}
        >
          {option.icon}
          <span className={styles.label}>{option.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ThemeToggle;
